import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { StorageLocationDetailsResponse } from 'src/apis/storage/types';
import type { PublicStorageLocationsRequest } from 'src/apis/storage/use-public-storage-locations';
import type { Successful } from 'src/hooks/use-axios';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  storageLocations?: PublicStorageLocationsRequest;
  locationId: string;
};

type ExecuteOptions = {
  storageLocations: Successful<PublicStorageLocationsRequest>;
  locationId: string;
};

export function useStorageLocationDetails({
  storageLocations,
  locationId,
}: HookOptions) {
  const storageLocation = useAxios(
    (axios, baseConfig, { storageLocations, locationId }: ExecuteOptions) => {
      const url = urlTemplate
        .parse(storageLocations.response.data._links.instance.href)
        .expand({ locationId });

      return axios.request<StorageLocationDetailsResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageLocations?.response) return;

    storageLocation.execute({
      storageLocations,
      locationId,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageLocations?.response, locationId]);

  return storageLocation;
}

export type StorageLocationDetailsRequest = ReturnType<
  typeof useStorageLocationDetails
>;
